import { z } from 'zod';

import { accreditationPhaseSchema } from 'entities/Accreditation';
import { accreditationStageSchema } from 'entities/Company';

import { baseNotificationRawSchema, baseNotificationRawSchemaParser } from './BaseNotification';

export const accreditationStageChangedNotificationType = z.literal('ACCREDITATION_STAGE_CHANGED');

export const accreditationStageChangedNotificationSchema = baseNotificationRawSchema
  .extend({
    type: accreditationStageChangedNotificationType,
    extra: z.object({
      stage: accreditationStageSchema,
      phase: accreditationPhaseSchema,
      company_name: z.string(),
      reason: z.string().nullable().optional(),
    }),
  })
  .transform((raw) => {
    return {
      ...baseNotificationRawSchemaParser(raw),
      type: raw.type,
      extra: {
        stage: raw.extra.stage,
        phase: raw.extra.phase,
        companyName: raw.extra.company_name,
        reason: raw.extra.reason ?? null,
      },
    };
  });

export type AccreditationStageChangedNotificationEntityApi = z.input<
  typeof accreditationStageChangedNotificationSchema
>;

export type AccreditationStageChangedNotificationEntity = z.infer<typeof accreditationStageChangedNotificationSchema>;
